module.exports = __webpack_public_path__ + "static/img/ban2.8c367cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban2.jpg
// module id = zlzt
// module chunks = 1